import { Container } from "components/layout/Container";
import { Heading } from "components/layout/Heading";
import type { FreeFeaturesCardProps } from "components/shared/cards/FreeFeaturesCard";
import { FreeFeaturesCard } from "components/shared/cards/FreeFeaturesCard";
import s from "./SectionFeatures.module.scss";
import cs from "@/styles/modules/card.module.scss";
import { IconImageType } from "@/types/icon";
import cn from "classnames";
import { WrappedIcon } from "@/components/UI/WrappedIcon";

export type SectionFeaturesProps = {
  heading: string;
  subheading: string;
  cards: {
    icon?: IconImageType;
    heading: string;
    text: string;
  }[];
  featureCard: Omit<FreeFeaturesCardProps, "className">;
};

export const SectionFeatures = ({ heading, subheading, cards, featureCard }: SectionFeaturesProps) => (
  <section className={s.section}>
    <Container className={s.container}>
      <Heading
        title={heading}
        subheading={subheading}
        image="/img/icons/60/icon-writing-hand.png"
        className={s.heading}
      />
      <div className={s.main}>
        <div className={s.cardsWrap}>
          {cards.map((card, index) => (
            <div key={String(card.icon) + index} className={cn(cs.cardGlassHover, s.card)}>
              {card.icon && <WrappedIcon icon={card.icon} />}
              <strong className={cs.h4}>{card.heading}</strong>
              <p>{card.text}</p>
            </div>
          ))}
        </div>
        <FreeFeaturesCard className={s.featuresCard} {...featureCard} />
      </div>
    </Container>
  </section>
);

export default SectionFeatures;
